import  * as actionTypes from './actions';
import { AxiosError } from 'axios';

type State = {
  pageLoading: boolean;
  pageData: {[key:string]:any} | null;
  error: AxiosError | null;
};

const initiaState = {
  pageLoading: false,
  pageData: null,
  error: null
};

export default function pages(
  state: State = initiaState,
  action: actionTypes.GetPagesActionsType
): State {
  switch (action.type) {
    case actionTypes.PAGE_INIT:
      return {
        ...state,
        pageLoading: true
      };
    case actionTypes.PAGE_SUCCESS:
      return {
        ...state,
        pageLoading: false,
        pageData: action.payload
      }
    case actionTypes.PAGE_ERROR:
      return {
        ...state,
        pageLoading: false,
        error: action.error
      }
      case actionTypes.PAGE_CREATE_INIT:
        return {
          ...state,
          pageLoading: true,
        }
      case actionTypes.PAGE_CREATE_SUCCESS:
        return {
          ...state,
          pageLoading: false,
          pageData: action.payload
        }
      case actionTypes.PAGE_CREATE_ERROR:
        return {
          ...state,
          pageLoading: false,
          error: action.error
        }   
    case actionTypes.PAGE_UPDATE_INIT:
      return {
        ...state,
        pageLoading: true,
        
      }
    case actionTypes.PAGE_UPDATE_SUCCESS:
      return {
        ...state,
        pageLoading: false,
        pageData: action.payload
      }
    case actionTypes.PAGE_UPDATE_ERROR:
      return {
        ...state,
        pageLoading: false,
        error: action.error
      }
      case actionTypes.PAGE_DELETE_INIT:
        return {
          ...state,
          pageLoading: true,
        }  
    case actionTypes.PAGE_DELETE_SUCCESS:
      return {
        ...state,
        pageLoading: false,
        pageData: action.payload
      }
    case actionTypes.PAGE_DELETE_ERROR:
      return {
        ...state,
        pageLoading: false,
        error: action.error
      }
    default:
      return state;
  }
}
